import './bootstrap';

window.onload = function() {
  if (window.jQuery) {
    $('#app-loader').hide();
  } else {
    console.log("Something Wrong With Your JQuery");
  }
}

// function textAreaAdjust(e) {
//   let scHeight = e.scrollHeight;
//   let height = e.style.height;

//   if (scHeight <= 144) {
//     e.style.height = (e.scrollHeight)+"px";
//   } else {
//     e.style.height = "144px";
//   }
//   console.log(scHeight);
//   console.log(height);
// }
